var _path, _rect, _path2, _circle, _path3, _path4, _circle2, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmallImage = function SvgSmallImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 644 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.281 133.432 213.393 257.189a42.421 42.421 0 0 0-9.479 59.243l2.018 2.789a42.423 42.423 0 0 0 59.244 9.479l170.888-123.757a42.421 42.421 0 0 0 9.479-59.243l-2.018-2.789a42.423 42.423 0 0 0-59.244-9.479Z",
    fill: "#F98971"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 449.188,
    y: 272,
    width: 75.444,
    height: 75.444,
    rx: 11.121,
    transform: "rotate(5.467 449.188 272)",
    fill: "#DFF994"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m482.251 298.574 3.199 10.024-3.864 5.8-.091.154-7.577-.725-2.28 4.159-4.338-.415 10.613-19.413 4.338.416Zm8.986 5.967 5.14 12.165a7.132 7.132 0 1 1-12.689-.911l.181-.286 7.368-10.968Zm-15.053 5.125 3.414-6.239 2.167 6.774-5.581-.535Z",
    fill: "#00935F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 331.376,
    cy: 59.377,
    r: 45.285,
    transform: "rotate(10.153 331.376 59.377)",
    fill: "#D8E2EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.176 36.798a11.182 11.182 0 0 0-12.977 9.035l-.477 2.663a4.02 4.02 0 0 0-4.197 3.304l-2.833 15.821a4.019 4.019 0 0 0 3.247 4.664l21.096 3.778a4.02 4.02 0 0 0 4.664-3.247l2.833-15.822a4.02 4.02 0 0 0-2.797-4.556l.476-2.663a11.178 11.178 0 0 0-9.035-12.977Zm5.01 14.977.472-2.637a7.572 7.572 0 0 0-14.905-2.669l-.472 2.637 14.905 2.67Z",
    fill: "#9EB4CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.357 202.194c5.416 10.933.944 24.187-9.989 29.603l-15.513 7.685c-10.933 5.417-24.187.944-29.603-9.989l-40.445-81.638c-5.416-10.933-.944-24.187 9.989-29.604l35.309-17.492 14.568 29.405.011-.008c-7.606-16.557-.707-36.267 15.729-44.41l35.818-17.744 30.029 60.615-19.547 9.684c10.885-5.227 23.979-.74 29.354 10.11l10.416 21.024c5.416 10.933.944 24.186-9.989 29.603l-46.33 22.952-9.807-19.796Z",
    fill: "#00524E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.112,
    cy: 315.112,
    r: 43.112,
    fill: "#8FA3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.913 294.121a1.2 1.2 0 0 1 1.177.965l.258 1.293a5.999 5.999 0 0 0 4.707 4.706l1.293.259a1.2 1.2 0 0 1 0 2.353l-1.293.259a5.999 5.999 0 0 0-4.707 4.706l-.258 1.293a1.2 1.2 0 0 1-2.354 0l-.258-1.293a5.999 5.999 0 0 0-4.706-4.706l-1.294-.259a1.2 1.2 0 0 1 0-2.353l1.294-.259a5.999 5.999 0 0 0 4.706-4.706l.258-1.293a1.2 1.2 0 0 1 1.177-.965ZM40.115 301.32a1.2 1.2 0 0 1 1.157.885l1.074 3.938a15.599 15.599 0 0 0 10.945 10.944l3.938 1.074a1.2 1.2 0 0 1 0 2.315l-3.938 1.074a15.602 15.602 0 0 0-10.945 10.945l-1.074 3.938a1.2 1.2 0 0 1-2.315 0l-1.074-3.938a15.601 15.601 0 0 0-10.945-10.945L23 320.476a1.199 1.199 0 0 1 0-2.315l3.938-1.074a15.598 15.598 0 0 0 10.945-10.944l1.074-3.938a1.2 1.2 0 0 1 1.158-.885Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m622.344 152.774-32.286-18.811 17.086-22.631a6.918 6.918 0 0 0 .763-7.067 6.88 6.88 0 0 0-5.842-4.024l-96.461-6.362a6.974 6.974 0 0 0-6.427 3.376c-1.34 2.24-1.27 5.049.123 7.261l51.895 81.189a6.925 6.925 0 0 0 6.323 3.167 6.91 6.91 0 0 0 5.816-4.047l11.653-25.576 32.444 18.893c1.501.892 3.213 1.122 4.817.808a6.956 6.956 0 0 0 4.638-3.28l7.903-13.435c.93-1.594 1.21-3.484.722-5.252-.46-1.774-1.633-3.295-3.199-4.231l.032.022Z",
    fill: "#FED980"
  })));
};
export default SvgSmallImage;